<script lang="ts" setup>
import HomeIntro from "./HomeIntro/index.vue";

type Props = {
  name: string;
  subtitle: string;
  imageSrc: string;
  email: string;
  presentation: string;
};
const props = defineProps<Props>();
const title = `Hi, I'm ${props.name}`;
</script>
<template>
  <header class="lg:block flex flex-col justify-between">
    <div class="lg:min-h-auto pt-16 lg:pt-0 min-h-screen flex flex-col">
      <!-- Image & Description -->
      <div
        class="flex flex-col lg:grid lg:grid-cols-12 lg:centered-container lg:content-width"
      >
        <!-- Description (Desktop Only) -->
        <div class="col-span-4 col-start-2 hidden lg:block">
          <div class="h-full flex items-center lg:pb-12">
            <p
              v-dompurify-html="presentation"
              class="text-md leading-6 lg:text-[14px] lg:leading-[28px] xl:text-[16px] xl:leading-[34px] 2xl:text-[20px] 2xl:leading-[40px] font-medium text-primary-800 dark:text-primary-200"
            />
          </div>
        </div>
        <!-- Image -->
        <div class="col-start-7 col-span-6">
          <UiProfileAvatar
            :src="props.imageSrc"
            :alt="`${props.name} - ${props.subtitle}`"
          />
        </div>
      </div>
      <!-- Title & Address -->
      <div class="flex md:flex-col lg:block grow lg:grow-0">
        <HomeIntro :title="title" :subtitle="subtitle">
          <template #social>
            <slot name="social" />
          </template>
        </HomeIntro>
      </div>
    </div>
    <!-- Description (Mobile Only) -->
    <div class="centered-container content-width lg:hidden block">
      <div class="pt-20">
        <UiParagraph
          v-dompurify-html="presentation"
          class="leading-8 text-lg font-light"
        />
      </div>
    </div>
  </header>
</template>

<style lang="css">
.bg-header {
  background-color: var(--app-header-bg);
}
</style>
